import { render, staticRenderFns } from "./Valorant.vue?vue&type=template&id=5fe95ac1&"
import script from "./Valorant.vue?vue&type=script&lang=js&"
export * from "./Valorant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports